import { render, staticRenderFns } from "./order-dialog.vue?vue&type=template&id=b1beaaf6"
import script from "./order-dialog.vue?vue&type=script&lang=js"
export * from "./order-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports